import './disabledlink';
import './lightbox';
import './navigation';
import './gdpr_consent';
import './consent_pref_center';
//import './analytics';
//import './googletagmanager';


export async function importFileIfElementExists(selector: string, filePath: string) {
    if (document.querySelector(selector)) {
      await import(filePath);
    }
}

// accordion
importFileIfElementExists('.accordion__header', './accordion');

// product carousel
importFileIfElementExists('.product-accordion', './products');

// ContentBlock Background Img
importFileIfElementExists('.is-wide .contentblock-wide.contentgroup-wide', './contentblock');

// Solo Hero Background Img
importFileIfElementExists('.is-wide .solo-hero-wide .bg-image', './solo-hero');

// Marker highlight Styling Effect
importFileIfElementExists('.is-wide', './highlight-marker');